import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--rovo-expansion/townsquare-side-nav';

import { NonMauChatCtaMessage } from '../../../common/components/NonMauChatCtaMessage';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<PlacementRenderProps>(),
		Component: ({ dismiss }: PlacementRenderProps) => {
			return (
				<NonMauChatCtaMessage
					handleOnDismissed={dismiss}
					context={{
						source: 'townsquare-side-nav',
					}}
				/>
			);
		},
	},
});
